import i18next from 'i18next';
import {
  requestApiGet,
  requestApiPost,
  requestApiPut,
  getErrorMessage
} from 'Parts/common/requestUtils';
import {
  notification
} from 'antd';
import {
  fetchTransactionById
} from '../../../donation/donationActions';
import {
  updateOrganization
} from '../../../organization/organizationActions';
import {
  fetchCountries,
  fetchProvinces
} from 'Parts/geo/geoActions';

export const SHOW_TAXRECEIPT_FIELD = 'SHOW_TAXRECEIPT_FIELD';
export const HIDE_TAXRECEIPT_FIELD = 'HIDE_TAXRECEIPT_FIELD';
export const DOWNLOAD_TAXRECEIPT_START = 'DOWNLOAD_TAXRECEIPT_START';
export const DOWNLOAD_TAXRECEIPT_SUCCESS = 'DOWNLOAD_TAXRECEIPT_SUCCESS';
export const DOWNLOAD_TAXRECEIPT_ERROR = 'DOWNLOAD_TAXRECEIPT_ERROR';
export const CANCEL_TAXRECEIPT_START = 'CANCEL_TAXRECEIPT_START';
export const CANCEL_TAXRECEIPT_SUCCESS = 'CANCEL_TAXRECEIPT_SUCCESS';
export const CANCEL_TAXRECEIPT_ERROR = 'CANCEL_TAXRECEIPT_ERROR';
export const REGENERATE_TAXRECEIPT_START = 'REGENERATE_TAXRECEIPT_START';
export const REGENERATE_TAXRECEIPT_SUCCESS = 'REGENERATE_TAXRECEIPT_SUCCESS';
export const REGENERATE_TAXRECEIPT_ERROR = 'REGENERATE_TAXRECEIPT_ERROR';
export const GENERATE_TAXRECEIPT_START = 'GENERATE_TAXRECEIPT_START';
export const GENERATE_TAXRECEIPT_SUCCESS = 'GENERATE_TAXRECEIPT_SUCCESS';
export const GENERATE_TAXRECEIPT_ERROR = 'GENERATE_TAXRECEIPT_ERROR';
export const RESEND_TAXRECEIPT_START = 'RESEND_TAXRECEIPT_START';
export const RESEND_TAXRECEIPT_SUCCESS = 'RESEND_TAXRECEIPT_SUCCESS';
export const RESEND_TAXRECEIPT_ERROR = 'RESEND_TAXRECEIPT_ERROR';
export const FETCH_TAXRECEIPT_LOGS_START = 'FETCH_TAXRECEIPT_LOGS_START';
export const FETCH_TAXRECEIPT_LOGS_SUCCESS = 'FETCH_TAXRECEIPT_LOGS_SUCCESS';
export const FETCH_TAXRECEIPT_LOGS_ERROR = 'FETCH_TAXRECEIPT_LOGS_ERROR';
export const FETCH_TAXRECEIPT_CONFIGURATION_START = 'FETCH_TAXRECEIPT_CONFIGURATION_START';
export const FETCH_TAXRECEIPT_CONFIGURATION_SUCCESS = 'FETCH_TAXRECEIPT_CONFIGURATION_SUCCESS';
export const FETCH_TAXRECEIPT_CONFIGURATION_ERROR = 'FETCH_TAXRECEIPT_CONFIGURATION_ERROR';
export const UPDATE_TAXRECEIPT_CONFIGURATION_START = 'UPDATE_TAXRECEIPT_CONFIGURATION_START';
export const UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS = 'UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS';
export const UPDATE_TAXRECEIPT_CONFIGURATION_ERROR = 'UPDATE_TAXRECEIPT_CONFIGURATION_ERROR';
export const FETCH_TAXRECEIPT_CONFIGURATION_LOGS_START =
'FETCH_TAXRECEIPT_CONFIGURATION_LOGS_START';
export const FETCH_TAXRECEIPT_CONFIGURATION_LOGS_SUCCESS =
  'FETCH_TAXRECEIPT_CONFIGURATION_LOGS_SUCCESS';
export const FETCH_TAXRECEIPT_CONFIGURATION_LOGS_ERROR =
'FETCH_TAXRECEIPT_CONFIGURATION_LOGS_ERROR';
export const UI_TAX_RECEIPT_DONATION_CLEAR = 'UI_TAX_RECEIPT_DONATION_CLEAR';

export const FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_START =
  'FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_START';
export const FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_SUCCESS =
  'FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_SUCCESS';
export const FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_ERROR =
  'FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_ERROR';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_START =
  'FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_START';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_SUCCESS =
  'FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_SUCCESS';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_ERROR =
  'FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_ERROR';
export const UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START =
  'UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START';
export const UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS =
  'UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS';
export const UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR =
  'UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START = 'FETCH_TAX_RECEIPT_CAMPAIGN_START';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS =
  'FETCH_TAX_RECEIPT_CAMPAIGN_SUCCESS';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR = 'FETCH_TAX_RECEIPT_CAMPAIGN_ERROR';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_START =
  'FETCH_TAX_RECEIPT_CAMPAIGN_LOGS_START';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_SUCCESS =
  'FETCH_TAX_RECEIPT_CAMPAIGN_LOGS_SUCCESS';
export const FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_ERROR =
  'FETCH_TAX_RECEIPT_CAMPAIGN_LOGS_ERROR';

export const UNMOUNT_TAX_RECEIPT = 'UNMOUNT_TAX_RECEIPT';

// function getErrorMessage(code, t = i18next.t, defaultMessage = '') {
//   const message = t(`ERROR:${code}`);
//   return message === code ? t(defaultMessage) : message;
// }

export function onChangeDonationTypeField(event, form) {
  return dispatch => {
    switch (event.target.value) {
      case 1:
      case 2:
        return dispatch({
          type: SHOW_TAXRECEIPT_FIELD
        });
      default:
        form.setFieldsValue({
          taxReceipt: null
        });
        return dispatch({
          type: HIDE_TAXRECEIPT_FIELD
        });
    }
  };
}

export function downloadTaxReceipt(event, transactionId, taxReceiptId, taxReceiptNumber, t = null) {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_TAXRECEIPT_START
    });
    return requestApiGet(`/plugins/taxReceipt/${transactionId}/download/${taxReceiptId}`)
      .then(pdf => {
        const data = new Blob(
          [pdf], {
            type: 'application/pdf'
          });
        const url = URL.createObjectURL(data);
        window.open(url);
        //window.URL.revokeObjectURL(url);

        // Try to set taxReceiptNumber as file name.
        // const saveData = (function () {
        //   const a = document.createElement("a");
        //   document.body.appendChild(a);
        //   a.style = "display: none";
        //   return function (data, fileName) {
        //     const blob = new Blob([data], {type: "application/pdf"}),
        //           url = window.URL.createObjectURL(blob);
        //     a.href = url;
        //     a.download = fileName;
        //     a.click();
        //     window.open(url);
        //     window.URL.revokeObjectURL(url);
        //   };
        // }());
        // saveData(pdf, taxReceiptNumber + ".pdf");
      })
      .then(() => dispatch(fetchTaxReceiptLogs(transactionId)))
      .then(() => dispatch({
        type: DOWNLOAD_TAXRECEIPT_SUCCESS
      }))
      .catch(error => {
        if (t) notification.error({
          message: t('notification.download.error.title'),
          description: t('notification.download.error.message')
        });
        return dispatch({
          type: DOWNLOAD_TAXRECEIPT_ERROR,
          error
        });
      });
  };
}

export function cancelTaxReceipt(event, transactionId, reason = "CANCELED", t = null) {
  return dispatch => {
    dispatch({
      type: CANCEL_TAXRECEIPT_START
    });
    const values = {
      transactionId,
      reason
    };
    return requestApiPut(`/plugins/taxReceipt`, values)
      .then(payload => {
        return Promise.all([
            dispatch(fetchTaxReceiptLogs(transactionId)),
            dispatch(fetchTransactionById(transactionId)),
            dispatch(resendTaxReceipt(event, transactionId, payload.id, t))
          ])
          .then(() => payload);
      })
      .then(payload => {
        if (t) notification.success({
          message: t('notification.cancel.success.title'),
          description: t('notification.cancel.success.message')
        });
        return dispatch({
          type: CANCEL_TAXRECEIPT_SUCCESS,
          payload
        })
      })
      .catch(error => {
        if (t) notification.error({
          message: t('notification.cancel.error.title'),
          description: t('notification.cancel.error.message')
        });
        return dispatch({
          type: CANCEL_TAXRECEIPT_ERROR,
          error
        });
      });
  };
}

export function regenerateTaxReceipt(event, transactionId, reason = "REGENERATED", t = null) {
  return dispatch => {
    dispatch({
      type: REGENERATE_TAXRECEIPT_START
    });
    const values = {
      transactionId,
      reason
    };
    return requestApiPut(`/plugins/taxReceipt`, values)
      .then(cancelled => {
        const values2 = {
          transactionId
        };
        return requestApiPost(`/plugins/taxReceipt`, values2)
          .then(payload => {
            return Promise.all([
                dispatch(fetchTaxReceiptLogs(transactionId)),
                dispatch(fetchTransactionById(transactionId)),
                dispatch(resendTaxReceipt(event, transactionId, payload.id, t))
              ])
              .then(() => payload);
          })
          .then(payload => {
            if (t) notification.success({
              message: t('notification.regenerate.success.title'),
              description: t('notification.regenerate.success.message')
            });
            return dispatch({
              type: REGENERATE_TAXRECEIPT_SUCCESS,
              payload
            });
          })
          .catch(error => {
            if (t) notification.error({
              message: t('notification.regenerate.error.title'),
              description: getErrorMessage(error.code, t,
                'notification.generate.error.message')
            });
            return dispatch({
              type: REGENERATE_TAXRECEIPT_ERROR,
              error
            });
          });
      })
      .catch(error => {
        if (t) notification.error({
          message: t('notification.regenerate.error.title'),
          description: t('notification.regenerate.error.message')
        });
        return dispatch({
          type: REGENERATE_TAXRECEIPT_ERROR,
          error
        })
      });
  };
}

export function generateTaxReceipt(event, transactionId, t = null) {
  return dispatch => {
    dispatch({
      type: GENERATE_TAXRECEIPT_START
    });
    const values = {
      transactionId
    };
    return requestApiPost(`/plugins/taxReceipt`, values)
      .then(payload => {
        return Promise.all([
            dispatch(fetchTransactionById(transactionId)),
            dispatch(resendTaxReceipt(event, transactionId, payload.id, t))
          ])
          .then(() => payload);
      })
      .then(payload => {
        dispatch(fetchTaxReceiptLogs(transactionId));
        return payload
      })
      .then(payload => {
        if (t) notification.success({
          message: t('notification.generate.success.title'),
          description: t('notification.generate.success.message')
        });
        return dispatch({
          type: GENERATE_TAXRECEIPT_SUCCESS,
          payload
        });
      })
      .catch(error => {
        if (t) notification.error({
          message: t('notification.generate.error.title'),
          description: getErrorMessage(error.code, t, 'notification.generate.error.message')
        });
        return dispatch({
          type: GENERATE_TAXRECEIPT_ERROR,
          error
        });
      });
  };
}

export function resendTaxReceipt(event, transactionId, taxReceiptId, t = null) {
  return dispatch => {
    dispatch({
      type: RESEND_TAXRECEIPT_START
    });
    return requestApiGet(`/plugins/taxReceipt/${transactionId}/send/${taxReceiptId}`)
      .then(payload => {
        return Promise.all([
            dispatch(fetchTaxReceiptLogs(transactionId))
          ])
          .then(() => payload);
      })
      .then(payload => {
        if (t) notification.success({
          message: t('notification.resend.success.title'),
          description: t('notification.resend.success.message')
        });
        return dispatch({
          type: RESEND_TAXRECEIPT_SUCCESS,
          payload
        })
      })
      .catch(error => {
        if (t) notification.error({
          message: t('notification.resend.error.title'),
          description: getErrorMessage(error.code, t, 'notification.resend.error.message')
        });
        return dispatch({
          type: RESEND_TAXRECEIPT_ERROR,
          error
        })
      });
  };
}

export function fetchTaxReceiptLogs(transactionId) {
  return dispatch => {
    dispatch({
      type: FETCH_TAXRECEIPT_LOGS_START
    });
    return requestApiGet(`/plugins/taxReceipt/${transactionId}/logs`, {
        pageResults: 100
      }, {
        authentication: 'true'
      })
      .then(logs => {
        return dispatch({
          type: FETCH_TAXRECEIPT_LOGS_SUCCESS,
          payload: logs
        })
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TAXRECEIPT_LOGS_ERROR,
          error
        })
      });
  };
}

export function fetchTaxReceiptConfiguration() {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_TAXRECEIPT_CONFIGURATION_START
    });
    const platformId = getState().platform.platform.id;
    return requestApiGet(`/plugins/taxReceipt/platform/${platformId}`)
      .then(configuration => {
        return dispatch({
          type: FETCH_TAXRECEIPT_CONFIGURATION_SUCCESS,
          payload: configuration
        })
      })
      .catch(error => {
        return dispatch({
          type: FETCH_TAXRECEIPT_CONFIGURATION_ERROR,
          error
        })
      });
  };
}

export function updateTaxReceiptConfigurationActivation(formValues, statusId = 2) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_TAXRECEIPT_CONFIGURATION_START
    });
    const platformId = getState().platform.platform.id;

    const values = (
      formValues.statusId
    ) ? {
      statusId: formValues.statusId || statusId,
    } : null;

    return requestApiPut(`/plugins/taxReceipt/platform/${platformId}`, values)
      .then(() => dispatch(fetchTaxReceiptConfiguration()))
      .then(() => {
        notification.success({
          message: i18next.t('API_NOTIFICATIONS:success'),
          description: i18next.t('API_NOTIFICATIONS:modifications-saved')
        });
        return dispatch({
          type: UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS
        });
      })
      .catch((error) => {
        const description = error.description || error;
        notification.error({
          message: i18next.t('API_NOTIFICATIONS:modifications-failed'),
          description: description
        });
        return dispatch({
          type: UPDATE_TAXRECEIPT_CONFIGURATION_ERROR,
          error: error
        });
      });
  };
}

export function updateTaxReceiptConfigurationInformation(formValues, statusId = 2) {
  return (dispatch, getState) => {
    const platformId = getState().platform.platform.id;
    const values = (
      (formValues.prefix || formValues.prefix === null) ||
      formValues.sequence ||
      formValues.signature ||
      formValues.logo
    ) ? {
      prefix: formValues.prefix || (formValues.prefix === null ? null : undefined),
      sequence: formValues.sequence || undefined,
      signature: formValues.signature || undefined,
      logo: formValues.logo || undefined,
      statusId: statusId,
    } : null;

    if (values) {
      dispatch({
        type: UPDATE_TAXRECEIPT_CONFIGURATION_START
      });
      return requestApiPut(`/plugins/taxReceipt/platform/${platformId}`, values)
        .then(() => fetchTaxReceiptConfiguration())
        .then(() => {
          notification.success({
            message: i18next.t('API_NOTIFICATIONS:success'),
            description: i18next.t('API_NOTIFICATIONS:modifications-saved')
          });
          return dispatch({
            type: UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS
          });
        })
        .catch((error) => {
          const description = error.description || error;
          notification.error({
            message: i18next.t('API_NOTIFICATIONS:modifications-failed'),
            description: description
          });
          return dispatch({
            type: UPDATE_TAXRECEIPT_CONFIGURATION_ERROR,
            error: error
          });
        });
    }
  };
}

export function updateTaxReceiptConfigurationOrganizationDetails(formValues, statusId = 2) {
  return (dispatch, getState) => {
    const organizationId = getState().organization.organization.id;

    const organizationValues = (
      formValues.name ||
      formValues.registrationNumber ||
      formValues.address ||
      formValues.city ||
      formValues.postalCode ||
      formValues.country ||
      formValues.province
    ) ? {
      name: formValues.name || undefined,
      registerNumber: formValues.registrationNumber || undefined,
      address: formValues.address || undefined,
      city: formValues.city || undefined,
      postalCode: formValues.postalCode || undefined,
      country: formValues.country || undefined,
      province: formValues.province || undefined,
    } : null;

    if (organizationValues) {
      return dispatch(updateOrganization(organizationValues, organizationId));
    }
  };
}

export function updateTaxReceiptConfigurationPersonalization(formValues, statusId = 2) {
  return (dispatch, getState) => {
    const platformId = getState().platform.platform.id;
    const values = (
      formValues.logo || formValues.logo === null
    ) ? {
      logo: formValues.logo || (formValues.logo === null ? null : undefined),
      statusId: statusId,
    } : null;

    if (values) {
      dispatch({
        type: UPDATE_TAXRECEIPT_CONFIGURATION_START
      });
      return requestApiPut(`/plugins/taxReceipt/platform/${platformId}`, values)
        .then(() => fetchTaxReceiptConfiguration())
        .then(() => {
          notification.success({
            message: i18next.t('API_NOTIFICATIONS:success'),
            description: i18next.t('API_NOTIFICATIONS:modifications-saved')
          });
          return dispatch({
            type: UPDATE_TAXRECEIPT_CONFIGURATION_SUCCESS
          });
        })
        .catch((error) => {
          const description = error.description || error;
          notification.error({
            message: i18next.t('API_NOTIFICATIONS:modifications-failed'),
            description: description
          });
          return dispatch({
            type: UPDATE_TAXRECEIPT_CONFIGURATION_ERROR,
            error: error
          });
        });
    }
  };
}

export function clearTaxReceiptDonation() {
  return dispatch => dispatch({
    type: UI_TAX_RECEIPT_DONATION_CLEAR
  });
}

export function getTaxReceiptConfigurationLogs() {
  return (dispatch, getState) => {
    const platformId = getState().platform.platform.id;
    dispatch({
      type: FETCH_TAXRECEIPT_CONFIGURATION_LOGS_START
    });
    return requestApiGet(`/plugins/taxReceipt/platform/${platformId}/logs`)
      .then(logs => {
        return dispatch({
          type: FETCH_TAXRECEIPT_CONFIGURATION_LOGS_SUCCESS,
          payload: logs
        });
      })
      .catch((error) => {
        return dispatch({
          type: FETCH_TAXRECEIPT_CONFIGURATION_LOGS_ERROR,
          error: error
        });
      });
  };
}

export function fetchTaxReceiptPlatformIssuingEnabled(platformId) {
  return dispatch => {
    dispatch({
      type: FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_START
    });
    return requestApiGet(`/plugins/taxReceipt/platform/${platformId}/enabled`)
      .then(result => { // {enabled: true|false}
        return dispatch({
          type: FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        return dispatch({
          type: FETCH_TAX_RECEIPT_PLATFORM_ISSUING_ENABLED_ERROR,
          error: error
        });
      });
  };
}

export function fetchTaxReceiptCampaignIssuingEnabled(campaignId) {
  return dispatch => {
    dispatch({
      type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_START
    });
    return requestApiGet(`/plugins/taxReceipt/campaign/${campaignId}/enabled`)
      .then(result => { // {enabled: true|false}
        return dispatch({
          type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        return dispatch({
          type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_ENABLED_ERROR,
          error: error
        });
      });
  };
}

export function fetchTaxReceiptCampaignIssuingStatus(campaignId) {
  return dispatch => {
    dispatch({
      type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START
    });
    return requestApiGet(`/plugins/taxReceipt/campaign/${campaignId}`)
      .then(result => { // {statusId: 1 (Enabled) or 2 (Disabled)}
        return dispatch({
          type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        return dispatch({
          type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR,
          error: error
        });
      });
  };
}

export function updateTaxReceiptCampaignIssuingStatus(campaignId, value) {
  return dispatch => {
    dispatch({
      type: UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_START
    });
    const values = {
      statusId: value
    };
    return requestApiPut(`/plugins/taxReceipt/campaign/${campaignId}`, values)
      .then(result => { // {statusId: 1 (Enabled) or 2 (Disabled)}
        notification.success({
          message: i18next.t('API_NOTIFICATIONS:success'),
          description: i18next.t('API_NOTIFICATIONS:modifications-saved')
        });
        return dispatch({
          type: UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        const description = error.description || error;
        notification.error({
          message: i18next.t('API_NOTIFICATIONS:modifications-failed'),
          description: description
        });
        return dispatch({
          type: UPDATE_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_ERROR,
          error: error
        });
      });
  };
}

export function fetchTaxReceiptCampaignIssuingStatusLogs(campaignId) {
  return dispatch => {
    dispatch({
      type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_START
    });
    return requestApiGet(`/plugins/taxReceipt/campaign/${campaignId}`)
      .then(result => {
        return dispatch({
          type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_SUCCESS,
          payload: result
        });
      })
      .catch((error) => {
        return dispatch({
          type: FETCH_TAX_RECEIPT_CAMPAIGN_ISSUING_STATUS_LOGS_ERROR,
          error: error
        });
      });
  };
}

export function unmountTaxReceipt() {
  return dispatch => dispatch({
    type: UNMOUNT_TAX_RECEIPT
  });
}
